<template>
  <b-container>
    <b-container fluid="sm" style="padding-top: 20px">


      <b-card bg-variant="light">
        <b-form-group label-cols="3" label-cols-lg="2" label-size="md" label="Child Groups" label-for="child-selector">
          <ChildGroupSelector v-model="updatedChildGroups" :available-groups="groupList" :show-ids="false"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Name" label-for="first-name">
          <b-form-input id="company-name" size="sm" v-model="name"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Street Address"
                      label-for="streetAddress">
          <b-form-input id="streetAddress" size="sm" v-model="streetAddress"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="City"
                      label-for="city">
          <b-form-input id="city" size="sm" v-model="city"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="State"
                      label-for="state">
          <b-form-input id="state" size="sm" v-model="state"/>
        </b-form-group>
        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Zip Code"
                      label-for="zipCode">
          <b-form-input id="zipCode" size="sm" v-model="zipCode"/>
        </b-form-group>

        <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Telephone Number"
                      label-for="input-sm">
          <b-form-input id="telephoneNumber" size="sm" v-model="telephoneNumber"/>
        </b-form-group>

        <b-container fluid="sm">
          <div class="button-holder">
            <b-button class="submit-button" type="submit" @click="submit('userInfo')"
                      :disabled="!canSubmit" variant="primary">
              Submit
            </b-button>

            <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel
            </b-button>
          </div>
        </b-container>
      </b-card>
    </b-container>
  </b-container>

</template>

<script>
import Swal from "sweetalert2";
import ChildGroupSelector from "@/components/admin/ChildGroupSelector";

const emailRegex = /^([^@\s]+)@((?:[-a-z0-9]+\.)+[a-z]{2,})$/i;

export default {
  name: "UpdateParentCompany",
  props: {
    groupId: String
  },
  components: {
    ChildGroupSelector
  },
  data() {
    return {
      myGroupId: this.groupId || localStorage.getItem('adminImpersonationGroupId') || localStorage.getItem('groupId'),
      groupList: [],
      childGroups: [],
      id: '',
      name: '',
      streetAddress: '',
      city: '',
      state: '',
      zipCode: '',
      telephoneNumber: '',
      errors: [],
      isSubmitted: true,
      updatedChildGroups: []

    }
  },
  computed: {
    /*    computedCompany: function () {
          let self = this;
          if (this.groupList) {
            let company = this.groupList.find(function (val) {
              return val.id === self.createdUserGroup;
            });
            this.companyName = company ? company.name.split("(")[0] : "";
            return company ? company.name : "";
          }
          return "";
        },*/
    validateFirstName: function () {
      return this.firstName !== '';
    },
    validateName: function () {
      return this.name !== '';
    },
    validateTelephoneNumber: function () {
      return this.telephoneNumber !== '';
    },
    validateContactEmail: function () {
      return this.validateEmailAddress(this.email);
    },
    validateUsername: function () {
      return this.username !== '';
    },
    canSubmit: function () {
      return this.validateTelephoneNumber
          && this.validateFirstName && this.validateName;
    }
  },
  mounted() {
    console.log("About To mount");
    let self = this;
    let groupId = this.$route.params.id;
    this.$http.get(`/groups/parent-company/${groupId}`)
        .then(resp => {
          let parent = resp.data;
          self.id = parent.id;
          self.name = parent.name;
          self.streetAddress = parent.streetAddress;
          self.city = parent.city;
          self.state = parent.state;
          self.zipCode = parent.zipCode;
          self.telephoneNumber = parent.telephoneNumber;
          self.childGroups = parent.childGroups || [];

        }).catch(error => {
      alert("Unable to retrieve Parent Company.");
      alert(error);
    });
    this.$http.get("groups")
        .then(resp => {
          self.groupList = resp.data;
        })
        .then(() => {
          let myGroups = self.groupList.filter(group => {
            return self.childGroups.includes(group.id);
          })
              .map(group => {
                group.selected = true;
                let theIndex = self.groupList.findIndex(val => val.id === group.id);
                self.$set(self.groupList, theIndex, group)
                return group;
              });
          console.log("My Groups");
          console.log(myGroups);
          self.updatedChildGroups = JSON.parse(JSON.stringify(myGroups));
        })
        .catch(error => {
          let message = `Unable to retrieve groups: ${error.message}`;
          this.$toasted.show(message,
              {
                containerClass: 'super-toasty',
                iconPack: 'fontawesome',
                closeOnSwipe: true,
                action: {
                  text: 'DISMISS',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                },
                icon: {
                  name: 'fa-check-circle',
                  after: false,
                }
              })
              .goAway(5000);
        })

  },
  methods:
      {
        onChangeList: function ({source, destination}) {
          this.groupsList = source;
          this.createdUserGroups = Array.from(new Set(destination));
        },
        changedLabel: function () {
          alert("Group Selected");
        },
        validateEmailAddress: function (email) {
          return emailRegex.test(String(email).toLowerCase());
        },
        isFieldValid: function (fieldValue, defaultValue) {
          console.log(Object.keys(fieldValue));
          return fieldValue !== defaultValue && fieldValue !== "";
        },
        submit: function () {
          let self = this;
          let data;
          let url;

          url = 'groups/parent-company';
          data = {
            id: this.id,
            name: this.name,
            streetAddress: this.streetAddress,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            telephoneNumber: this.telephoneNumber,
            childGroups: this.updatedChildGroups.map(child => child.id) //scrubDefaultValue(this.childGroups)
          };

          this.$http.put(url, data, {
            headers: {
              'content-type': 'application/json'
            }
          })
              .then(function (response) {
                if (response.status === 202 || response.status === 200) {
                  self.displayResult(`Parent Company Updated successfully.`);
                }
              })
              .catch(function (error) {
                let issuesObject = error.response.data[0];
                // This may be an issue since companies may have the same name.
                if (issuesObject && issuesObject.field) {
                  Swal.fire("Parent Company Children Addition Failed",
                      `Creation failed, company with ${issuesObject.field} = ${issuesObject.value} already has a parent.`
                      , "error");
                } else {
                  Swal.fire("Parent Company creation Failed",
                      `Creation failed, with error: ${error.response.message}`
                      , "error");
                }
              });
        },
        scrubDefaultValue: function () {
          let userGroups = [];
          this.createdUserGroups.forEach(group => {
            if (group.id !== null) {
              userGroups.push(group.id);
            }
          })
          return userGroups;
        },
        cancel: function () {
          this.$router.push({path: '/my-account'});
        },
        displayResult: function (message) {
          this.$toasted.show(message,
              {
                containerClass: 'super-toasty',
                iconPack: 'fontawesome',
                closeOnSwipe: true,
                action: {
                  text: 'DISMISS',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0);
                  }
                },
                icon: {
                  name: 'fa-check-circle',
                  after: false,
                }
              })
              .goAway(5000);
        }
      }
}
</script>

<style scoped>
.cancel-button {
  margin-left: 10px;
  margin-top: 5px;
}

.submit-button {
  margin-left: 10px;
  margin-top: 5px;
}

.button-holder {
  horiz-align: center;
  display: flex; /*Requires vendor prefixes*/
  justify-content: center; /*Requires vendor prefixes*/
  align-items: center; /*Requires vendor prefixes*/
}
</style>
